






















import Vue from 'vue';
import Chart from '@/components/Chart.vue';
import { Run, ConfigChartGroup } from '@/generated';

export default Vue.extend({
  name: 'ChartGroup',
  components: {
    Chart,
  },
  props: {
    repo: { type: String, required: true },
    group: {
      type: Object as () => ConfigChartGroup,
      required: true,
    },
    runs: {
      type: Array as () => Run[],
      required: true,
    },
  },
});
